import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ExportForm } from '../';
import { ExportPageWrapper } from '../../core';
import { AuthContext } from '../../user/auth/context/auth-context';
import { checkExportFileStatus, generateExportFile, getExportFile } from '../export-services';
import retrieveFileName from '../utils/retrieve-filename';
import './export-page.scss';

const ExportPage = () => {
	const [isLoading, setIsLoading] = useState(false);

	const [errorMessage, setErrorMessage] = useState(null);


	const { user = {} } = useContext(AuthContext);
	const { excel_access: excelAccess = false } = user;
	const navigate = useNavigate();

	if (!excelAccess) {
		return navigate('/error-access');
	}


const handleFormSubmit = async (formData, event) => {
	event.preventDefault();
	setIsLoading(true);
	setErrorMessage(null);

	try {
		const response = await generateExportFile(formData);

		if (Array.isArray(response.data) && response.data.length === 0) {
			setErrorMessage('Aucun résultat pour votre recherche.');
			setIsLoading(false);
			return;
		}

		await checkFileStatus(response.data);
	} catch (error) {
		console.error('Erreur export:', error);
		setErrorMessage("Une erreur est survenue lors de la requête d'export.");
		setIsLoading(false);
	}
};




	const checkFileStatus = async (id) => {
		const statusResponse = await checkExportFileStatus(id);
		if (statusResponse?.data === 'succeed') {
			const document = await getExportFile(id);
			return downloadFile(document);
		} else if (statusResponse?.data === 'failed') {
			setErrorMessage("Une erreur est survenue lors de la génération de l'export.");
			setIsLoading(false);
		} else {
			setTimeout(() => checkFileStatus(id), 5000);
		}
	};

	const downloadFile = (documentResponse) => {
		const fileName = retrieveFileName(documentResponse);
		const fileURL = window.URL.createObjectURL(new Blob([documentResponse.data]));
		const link = document.createElement('a');
		link.download = fileName;
		link.href = fileURL;
		link.click();
		setIsLoading(false);
	};

	// page access verification
	if (!user?.role && !excelAccess) {
		return navigate('/error-access');
	}

	return (
		<ExportPageWrapper className={'export-form'} loading={isLoading}>
		
			<ExportForm
				onSubmitHandler={handleFormSubmit}
				isLoading={isLoading}
				errorMessage={errorMessage}
				clearErrorMessage={() => setErrorMessage(null)}
			/>

		</ExportPageWrapper>
	);
};

export default ExportPage;
